import {RootState} from '..';

export const selectTheme = (state: RootState) => state.prefs.theme;

/**
 * Whether to draw the dark theme. An explicit choice always wins; a user who
 * never chose (`null`) follows the OS `prefers-color-scheme`. Pure so it can
 * be tested without a browser: `useIsDarkTheme` (src/theme) supplies the live
 * media-query value.
 *
 * Webapp-only — this is the webapp's own `prefs` slice; mobile resolves its
 * theme separately and is unaffected.
 */
export const resolveIsDarkTheme = (
  preference: RootState['prefs']['theme'],
  systemPrefersDark: boolean,
): boolean => (preference ? preference === 'dark' : systemPrefersDark);

export const selectNetatmoWeatherChartView = (state: RootState) =>
  state.prefs.netatmoWeather.chartView;

export const selectNetatmoWeatherAnalysisChartView = (state: RootState) =>
  state.prefs.netatmoWeather.analysisChartView;

export const selectNetatmoEnergyChartView = (state: RootState) =>
  state.prefs.netatmoEnergy.chartView;

export const selectNetatmoEnergyAnalysisChartView = (state: RootState) =>
  state.prefs.netatmoEnergy.analysisChartView;

export const selectWeatherChartView = (state: RootState) =>
  state.prefs.weather.chartView;

export const selectChartGestureEnabled = (state: RootState) =>
  state.prefs.gesture.chart;

export const getLastNavigator = (state: RootState) =>
  state.prefs.lastNavigator || null;

export const selectSmallDecimals = (state: RootState) =>
  state.prefs.smallDecimals ?? true;

export const selectWindDirectionConvention = (state: RootState) =>
  state.prefs.windDirectionConvention ?? 'oceanographic';
